import { render, staticRenderFns } from "./EditarPerguntas.vue?vue&type=template&id=188f1304&scoped=true&"
import script from "./EditarPerguntas.vue?vue&type=script&lang=js&"
export * from "./EditarPerguntas.vue?vue&type=script&lang=js&"
import style0 from "./EditarPerguntas.vue?vue&type=style&index=0&id=188f1304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188f1304",
  null
  
)

export default component.exports